import axios from "axios";

const state = {
  pagination: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ["updated_at"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    mustSort: false,
    multiSort: false,
    totalItems: 0,
    rowsPerPageOptions: [25, 50, 75, 100]
  },
  surveys: [],
  survey: "",
  surveyName: "",
  surveyResponses: []
};

const actions = {
  getAllSurveys: ({ commit, dispatch }) => {
    return axios.get(`/surveys`)
      .then((resp) => {
        commit("getAllSurveysSuccess", resp.data.surveys);
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", "Unable to retrieve all surveys", { root: true });
        return Promise.reject(err);
      });
  },

  getSurvey: ({ commit, dispatch }, id) => {
    return axios.get(`/surveys/${id}`)
      .then((resp) => {
        commit("getSurveySuccess", resp.data.survey);
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  updateSurvey: ({ commit, dispatch }, survey) => {
    return axios.patch(`/surveys/${survey.id}`, survey)
      .then((resp) => {
        dispatch("snackbar/successMessage", `Successfully updated survey`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  getSurveyResponses: ({ commit, dispatch }, payload) => {
    return axios.get(`/survey-responses`, {
      params: {
        facility_ids: payload.facility_ids,
        survey_id: payload.survey_id,
        start_date: payload.start_date,
        end_date: payload.end_date,
        completed: payload.completed,
        first_name: payload.first_name,
        last_name: payload.last_name,
        page: payload.page,
        per_page: payload.per_page,
        order_by: payload.order_by,
        order_direction: payload.order_direction
      }
    })
      .then((resp) => {
        const surveys = resp.data.responses.data;

        const mappedSurveys = surveys.map(survey => {
          return (survey.response) ? { ...survey, completed: 1 } : { ...survey, completed: 0 };
        });
        commit("getSurveyResponsesSuccess", mappedSurveys);
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", "Unable to retrieve survey responses", { root: true });
        return Promise.reject(err);
      });
  },

  downloadSurveyResponses: ({ dispatch }, payload) => {
    return axios.get(`/survey-responses/download`, {
      params: {
        facility_ids: payload.facility_ids,
        survey_id: payload.survey_id,
        start_date: payload.start_date,
        end_date: payload.end_date,
        completed: payload.completed,
        first_name: payload.first_name,
        last_name: payload.last_name
      },
      responseType: "blob"
    })
      .then((resp) => {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "survey-responses.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        dispatch("snackbar/successMessage", `Successfully downloaded survey responses`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", "Unable to download survey responses", { root: true });
        return Promise.reject(err);
      });
  }
};

const mutations = {
  getAllSurveysSuccess: (state, surveys) => {
    state.surveys = surveys;
  },

  getSurveySuccess: (state, survey) => {
    state.survey = survey;
  },

  setSurveyName: (state, surveyName) => {
    state.surveyName = surveyName;
  },

  getSurveyResponsesSuccess: (state, surveyResponses) => {
    state.surveyResponses = surveyResponses;
  },

  setSurveyPagination: (state, payload) => {
    state.pagination = payload;
  }
};

export default {
  state,
  actions,
  mutations
};
